"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = require("react");
const libs_polyfills_1 = require("@hotelplan/libs.polyfills");
function useWindowResize(resizeListener, config = {}) {
    const { enable = true, throttle: throttleTimeout, initializeCall = false, } = config;
    const listenerRef = (0, react_1.useRef)(resizeListener);
    listenerRef.current = resizeListener;
    (0, react_1.useEffect)(function windowResizeEffect() {
        if (!enable) {
            return;
        }
        let isMounted = true;
        function onResize(event) {
            if (!isMounted)
                return;
            listenerRef.current(event);
        }
        if (initializeCall) {
            listenerRef.current(null);
        }
        const throttledListener = throttleTimeout
            ? (0, throttle_1.default)(onResize, throttleTimeout)
            : onResize;
        window.addEventListener('resize', throttledListener, libs_polyfills_1.optionsWithPassive);
        return function cleanup() {
            isMounted = false;
            window.removeEventListener('resize', throttledListener);
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [enable, throttleTimeout]);
}
exports.default = useWindowResize;
//# sourceMappingURL=useWindowResize.js.map